import RevenueCenter from './RevenueCenter'

export default RevenueCenter
